import React, { createElement } from 'react'
import { ExternalLink } from 'lucide-react'

import { MIDDLE_ICON_SIZE } from 'src/features/AppSidebar/constants'
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'src/components/shadcn/card'
import { DashboardCardProps } from 'src/components/DashboardCard/types'

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  content,
  icon,
  onClick,
}) => {
  return (
    <Card className="rounded-xl border bg-card text-card-foreground shadow">
      <CardHeader>
        <CardTitle className="tracking-tight text-2xl font-bold">
          <div className="flex flex-row justify-between">
            <span>{title}</span>
            {icon &&
              createElement(icon, {
                size: MIDDLE_ICON_SIZE,
                strokeWidth: 2,
              })}
          </div>
        </CardTitle>
        <CardDescription>
          <div className="text-xl font-bold flex flex-row justify-between">
            {content}
            {onClick && (
              <button onClick={onClick}>
                <ExternalLink />
              </button>
            )}
          </div>
        </CardDescription>
      </CardHeader>
    </Card>
  )
}

export default DashboardCard
